export default "__VITE_ASSET__602cb8a4__"